// Pequeño formulario que aparece cuando el usuario ha olvidado su contraseña

import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";

export default class FormContraseñaOlvidadada extends Component {
  render() {
    return (
      <Form className=" p-4" autoComplete="off" onSubmit={this.props.contraseñaOlvidadaPost}>
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              <p>Introduzca su correo para poder restaurar su contraseña</p>
            </small>
          </Form.Row>
          <Form.Label>Email *</Form.Label>
          <Form.Control required type="email" name="email" maxLength="320" autoComplete="nope" />
        </Form.Group>
        <Form.Group>
          <Button variant="outline-dark" type="submit" className="btn btn-block mt-5">
            Enviar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
